/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

let firstLoad = true;
function updateButtonState() {
  const cartCheckoutButton = document.getElementById('cart-checkout');
  const selectElementWhoIsFor = document.getElementById('who_is_for');
  const selectElementDeliveryLocation = document.getElementById('delivery_location');
  // Get the first element with the class 'gift-fields' and display none
  const visibleGiftFields = document.querySelector('.gift-fields[style*="display: block;"]');

  if (cartCheckoutButton && selectElementWhoIsFor && selectElementDeliveryLocation) {
      const isWhoIsForVisible = selectElementWhoIsFor.closest('.form-field').style.display !== 'none';
      const isWhoIsForSelected = selectElementWhoIsFor.value !== '';
      const isDeliveryLocationSelected = selectElementDeliveryLocation.value !== '';

      if ((isWhoIsForVisible && !isWhoIsForSelected) || visibleGiftFields != null || !isDeliveryLocationSelected) {
          let disableButton = false;
          // Show the native required message for who_is_for if visible and not selected
          if (firstLoad) {
            disableButton = true;
            firstLoad = false;
          } else {
            if (isWhoIsForVisible && !isWhoIsForSelected) {
                selectElementWhoIsFor.reportValidity();
                disableButton = true;
            }
            if (!isDeliveryLocationSelected) {
                selectElementDeliveryLocation.reportValidity();
                disableButton = true;
            }
            if (visibleGiftFields!= null) {
                const giftFieldsContainers = document.querySelectorAll('.gift-fields');

                // Loop through each .gift-fields container
                giftFieldsContainers.forEach(giftFields => {
                  // Get all input and textarea fields within the current .gift-fields container
                  const giftElements = giftFields.querySelectorAll('input, textarea');

                  // Loop through each input and textarea field
                  giftElements.forEach(giftElement => {
                      // Check if the span element is already added for this field
                      let requiredText = giftElement.nextElementSibling;
                      if (!requiredText || !requiredText.classList.contains('required-text')) {
                          // If the span element is not added, create it
                          requiredText = document.createElement('span');
                          requiredText.textContent = 'This field is required';
                          requiredText.style.display = 'block'; // Initially hide the text
                          requiredText.classList.add('required-text'); // Add class to identify it

                          // Insert the span element after the current input or textarea field
                          giftElement.insertAdjacentElement('afterend', requiredText);
                      }

                      if (!giftElement.reportValidity() || !giftElement.value) {
                          requiredText.style.display = 'block';
                          disableButton = true;
                      } else {
                          requiredText.style.display = 'none';
                      }

                      // Function to update required text display
                      const updateRequiredText = () => {
                        if (!giftElement.checkValidity() || !giftElement.value) {
                            requiredText.style.display = 'block';
                        } else {
                            requiredText.style.display = 'none';
                        }
                      };

                      // Add input event listener for immediate feedback
                      giftElement.addEventListener('input', updateRequiredText);

                      // Add blur event listener to show validation message when moving away from the field
                      giftElement.addEventListener('blur', () => {
                          if (!giftElement.checkValidity() && giftElement.value) {
                              requiredText.style.display = 'block';
                          }
                      });
                  });
                });
            }
          }
          if(disableButton) {
            cartCheckoutButton.classList.add('disable-button');
          } else {
            cartCheckoutButton.classList.remove('disable-button');
          }
      } else {
          cartCheckoutButton.classList.remove('disable-button');
      }
  }
}

function updateGiftState() {
  const whoIsForVal = document.getElementById('who_is_for').value;
  const giftFields = document.querySelectorAll('.gift-fields');

  if (whoIsForVal === 'Myself' || whoIsForVal === '') {
      // Hide gift fields
      giftFields.forEach(field => {
          field.style.display = 'none';
      });
  } else {
      // Show gift fields
      giftFields.forEach(field => {
          field.style.display = 'block';
      });
  }
}

function initializeButtonAndListeners() {
  const cartCheckoutButton = document.getElementById('cart-checkout');
  const selectElementWhoIsFor = document.getElementById('who_is_for');
  const selectElementDeliveryLocation = document.getElementById('delivery_location');
  const giftFieldsContainers = document.querySelectorAll('.gift-fields');
  const firstGiftField = document.querySelector('.gift-fields');
  
  if (cartCheckoutButton && selectElementWhoIsFor && selectElementDeliveryLocation) {
      selectElementWhoIsFor.addEventListener('change', updateGiftState);
      setTimeout(() => {
        selectElementWhoIsFor.addEventListener('change', updateButtonState);
        selectElementDeliveryLocation.addEventListener('change', updateButtonState);
      }, 100);

      // Check if any gift field is visible
      const isAnyGiftFieldVisible = Array.from(firstGiftField.children).some(child => child.style.display !== 'none');

      // If any gift field is visible, add event listeners for input and textarea elements within .gift-fields container
      if (isAnyGiftFieldVisible) {
        // Loop through each .gift-fields container
        giftFieldsContainers.forEach(giftFields => {
          // Get all input and textarea fields within the current .gift-fields container
          const giftElements = giftFields.querySelectorAll('input, textarea');

          // Loop through each input and textarea field
          giftElements.forEach(giftElement => {
              giftElement.addEventListener('change', updateButtonState);
          });
        });
      }

      updateButtonState(); // Call to updateButtonState on load
  } else {
      console.error('Required elements not found.');
  }
}

function get_cart_fields() {
  const xhttp = new XMLHttpRequest();

  // Define a callback function
  xhttp.onload = function() {
    // Parse the JSON response
    const responseData = JSON.parse(xhttp.responseText);
    
    // Get the HTML data you want to print
    const cartFieldsHTML = responseData['cart-fields'];

    // Create a new div element to contain the HTML data
    const jsonDataDiv = document.createElement('div');
    // Set the innerHTML of the new div to the HTML data
    jsonDataDiv.innerHTML = cartFieldsHTML;

    // Get the cart checkout element by its ID
    const cartCheckout = document.getElementById('cart-checkout');

    // Insert the HTML data div before the cart checkout element
    cartCheckout.parentNode.insertBefore(jsonDataDiv, cartCheckout);

    // Once the elements are added, call the function to initialize button state and event listeners
    setTimeout(() => {
      initializeButtonAndListeners();
    }, 1000);
  }

  // Send a request
  xhttp.open('GET', '/?sections=cart-fields', true);
  xhttp.send();
}

if(document.getElementById('cart-checkout')) {
  get_cart_fields();
}

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    const target = event.target;
    // Traverse up the DOM tree to find the nearest ancestor with the class 'checkoutMethod'
    const closestCheckoutMethod = target.closest('.checkoutMethod');
    if (closestCheckoutMethod) {
        const methodNameElement = closestCheckoutMethod.querySelector('.checkoutMethodName');
        if (methodNameElement) {
            const methodName = methodNameElement.textContent.trim();
            const selectElement = document.getElementById('who_is_for');
            const selectElementDeliveryLocation = document.getElementById('delivery_location');
            if (selectElement && selectElementDeliveryLocation) {
                if (methodName === 'Store Pickup') {
                    // selectElement.removeAttribute('required');
                    // selectElement.closest('.form-field').style.display = 'none';
                    selectElementDeliveryLocation.value = 'Pick up';
                } else {
                    // selectElement.setAttribute('required', '');
                    // selectElement.closest('.form-field').style.display = 'block';
                    selectElementDeliveryLocation.value = '';
                }

                if (methodName === 'Store Pickup') {
                    const options = selectElementDeliveryLocation.querySelectorAll('option');
                    options.forEach(option => {
                        if (option.value === 'Pick up') {
                            option.disabled = false;
                        } else {
                            option.disabled = true;
                        }
                    });
                } else {
                    // Enable all options if methodName is not "Store Pickup"
                    const options = selectElementDeliveryLocation.querySelectorAll('option');
                    options.forEach(option => {
                      if (option.value === 'Pick up') {
                          option.disabled = true;
                      } else {
                          option.disabled = false;
                      }
                    });
                }
                selectElementDeliveryLocation.dispatchEvent(new Event('change'));
            } else {
                console.error('One or more required elements not found.');
            }
        } else {
            console.error('.checkoutMethodName element not found within closest .checkoutMethod.');
        }
    }
  });
});